import { ChangeEvent } from 'react';

import { css } from '@emotion/react';
import Checkbox from '@leafygreen-ui/checkbox';

import { FieldNames } from '@packages/types/auth/field';

import { checkbox } from './styles/form';

const checkboxCss = css(checkbox, {
  marginTop: 8,
});

export interface TermsOfServiceCheckboxProps {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export default function TermsOfServiceCheckbox({ checked = false, onChange, className }: TermsOfServiceCheckboxProps) {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      css={checkboxCss}
      label={
        <>
          I agree to the&nbsp;
          {/* JT: TODO: CLOUDP-44592 will update this link to point to generic TOS page */}
          <a target="_blank" rel="noopener noreferrer" href="http://www.mongodb.com/legal/evaluation-agreement">
            Evaluation Agreement
          </a>
        </>
      }
      className={className}
      name={FieldNames.TOS}
    />
  );
}
